var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.17 85.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #314a70;\r\n        stroke: #fff;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 4px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 42.58,
    cy: 42.58,
    r: 40.58
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.73,
    y: 19.14,
    width: 3.73,
    height: 42.02,
    rx: 1.86,
    ry: 1.86
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "67.15 43.9 42.58 41.28 42.58 32.76 67.15 38.54 67.15 43.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.02 43.9 42.59 41.2 42.59 32.76 18.02 38.54 18.02 43.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "49.92 66.03 42.57 62.85 42.57 54.89 49.92 60.67 49.92 66.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "35.22 66.03 42.57 62.84 42.57 54.89 35.22 60.67 35.22 66.03"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlider);
export default __webpack_public_path__ + "static/media/glider.0ab67080e4f1ea8c19d2bfafe6b75167.svg";
export { ForwardRef as ReactComponent };